// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

const _search = url =>
  wrapWithNetworkError(function search(
    token: string,
    query: { [string]: string }
  ) {
    const fetchUrl = getEndpointUrl(url);
    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        Authorization: token,
      },

      body: JSON.stringify(query),
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json());
  });

const _ugcSearch = url =>
  wrapWithNetworkError(function search(
    token: string,
    query: { [string]: string }
  ) {
    const params = new URLSearchParams(query);
    const clientId = params.get('client_id');
    const comments = params.get('comments_keywords');
    const endDate = params.get('end_date');
    const startDate = params.get('start_date');
    const codesIncluded = params.get('included_observations');
    const codesExcluded = params.get('excluded_observations');
    const questionHasVisualAnswer = params.get('includes_answer_media');
    const questionHasAnswer = params.get('includes_answer');
    const includesResponse = params.get('includes_response');
    const brand = params.get('brand');

    if (endDate && startDate) {
      params.append('from_date', startDate.slice(0, 10));
      params.append('to_date', endDate.slice(0, 10));
    }

    if (codesIncluded) {
      params.append('include_observation_type_codes', codesIncluded);
      params.delete('included_observations');
    }

    if (codesExcluded) {
      params.append('exclude_observation_type_codes', codesExcluded);
      params.delete('excluded_observations');
    }

    if (questionHasVisualAnswer) {
      params.append('has_visual_answer', questionHasVisualAnswer);
      params.delete('includes_answer_media');
    }

    if (questionHasAnswer) {
      params.append('has_answer', questionHasAnswer);
      params.delete('includes_answer');
    }

    if (includesResponse) {
      params.append('has_response', includesResponse);
      params.delete('includes_response');
    }

    params.append('max_page_results', 100);
    if (comments != null) {
      params.append('comments', params.get('comments_keywords'));
      params.delete('comments_keywords');
    }

    if (brand) {
      params.append('brand_name', brand);
      params.delete('brand');
    }
    params.delete('sort_order');
    params.delete('start_date');
    params.delete('end_date');
    params.delete('client_id');

    const fetchUrl = getEndpointUrl(`${url}/${clientId}?${params.toString()}`);
    const fetchOptions = {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        Authorization: token,
      },
    };

    return fetch(fetchUrl, fetchOptions)
      .then(response => checkResponse(response))
      .then(response => response.json());
  });

export const nativeSearch = _search('/cdm/ugc/search');
export const networkSearch = _search('/cdm/ugc/search/network');
export const ugcSearch = _ugcSearch('/cdm/ugc/search');



// WEBPACK FOOTER //
// ./src/api/content/search.js